import { inject, Pipe, PipeTransform } from '@angular/core';
import { AdminShipmentSizeType } from '../enums/admin-shipment-size-type';
import { Observable } from 'rxjs';
import { AdminShipmentSizeTypeProviderService } from '../providers';

@Pipe({
  name: 'adminShipmentSizeType',
})
export class AdminShipmentSizeTypePipe implements PipeTransform {
  private readonly provider = inject(AdminShipmentSizeTypeProviderService);

  public transform(size: AdminShipmentSizeType): Observable<string> {
    return this.provider.labelFor(size);
  }
}
